const FEATURE_FLAGS = JSON.parse(process.env.REACT_APP_FEATURE_FLAGS || "{}");
const DISABLE_COMPANY_LIST_CREATE_ON_COLUMN = FEATURE_FLAGS.DisableCompanyListCreateOnColumn;

const ProductTableCol = [
  {
    name: "Product Name",
    col: 4
  },
  {
    name: "Sales Unit",
    col: 3,
    information: "Click sales unit to see product mapping!"
  },
  {
    name: "Climate Change Impact (kgCO2eq/kg)",
    col: 3
  },
  {
    name: "EAN Barcode",
    col: 3
  },
  {
    name: "",
    col: 3
  }
];

const CompanyTableCol = [
  {
    name: "Name ",
    col: DISABLE_COMPANY_LIST_CREATE_ON_COLUMN ? 5 : 3
  },
  {
    name: "Email",
    col: 3
  },
  {
    name: "Status",
    col: 2
  },
  ...(!DISABLE_COMPANY_LIST_CREATE_ON_COLUMN
    ? [
        {
          name: "Created on",
          col: 5
        }
      ]
    : []),
  {
    name: "",
    col: DISABLE_COMPANY_LIST_CREATE_ON_COLUMN ? 6 : 3
  }
];

const UserTableCol = [
  {
    name: "Pic",
    col: 1
  },
  {
    name: "First Name",
    col: 2
  },
  {
    name: "Last Name",
    col: 2
  },
  {
    name: "Email",
    col: 2
  },
  {
    name: "Role",
    col: 1
  },
  {
    name: "Status",
    col: 1
  },
  {
    name: "",
    col: 3
  }
];

const IngredientTableColView = [
  {
    name: "Ingredient Name",
    col: 3
  },
  {
    name: "Supplier Name",
    col: 3
  },
  {
    name: "Unit Size",
    col: 1
  },
  {
    name: "Climate Change Impact (kgCO2eq/kg)",
    col: 3
  },
  {
    name: "Data Type",
    col: 2
  },
  {
    name: "EAN Barcode",
    col: 2
  },
  {
    name: "",
    col: 4
  }
];

const ChemicalTableColView = [
  {
    name: "Commercial Name",
    col: 3
  },
  {
    name: "Supplier Name",
    col: 3
  },
  {
    name: "Chemical Mix",
    col: 3
  },
  {
    name: "Chemical Change Impact per kg",
    col: 3
  },
  {
    name: "",
    col: 4
  }
];

const RecipeSimulatorTableColView = [
  {
    name: "",
    col: 1
  },
  {
    name: "Recipe Name",
    col: 1
  },
  {
    name: "Variation Name",
    col: 1
  },
  {
    name: "Baseline impact (kgCO2eq/kg)",
    col: 1,
    textAlign: "right"
  },
  {
    name: "Variation impact (kgCO2eq/kg)",
    col: 1,
    textAlign: "right"
  },
  {
    name: "Impact Change %",
    col: 1,
    textAlign: "right"
  },
  {
    name: "Updated Date",
    col: 1,
    textAlign: "right"
  },
  {
    name: "Calculated Date",
    col: 1,
    textAlign: "right"
  },
  {
    name: "",
    col: 3,
    textAlign: "right"
  }
];

const ClientTableCol = [
  {
    name: "Client Name",
    col: 7
  },
  {
    name: "Product Name",
    col: 7
  },
  {
    name: "",
    col: 3
  }
];
const ClientListTableCol = [
  {
    name: "Client Name",
    col: 6
  },
  {
    name: "Email",
    col: 6
  },
  {
    name: "Phone Number",
    col: 4
  }
];

const TransportTableCol = [
  {
    name: "Product Name",
    col: 4
  },
  {
    name: "Client Name",
    col: 4
  },
  {
    name: "Process Type",
    col: 2
  },
  {
    name: "Climate Impact",
    col: 3
  },
  {
    name: "",
    col: 3
  }
];

const PesticideTableHeader = [
  {
    name: "Pesticide Name",
    col: 6
  },
  {
    name: "kg/ha",
    col: 6
  },
  {
    name: "",
    col: 4
  }
];

const IrrigationTableHeader = [
  {
    name: "Irrigation Method",
    col: 3
  },
  {
    name: "Power Source",
    col: 3
  },
  {
    name: "Water Amount (m3)",
    col: 3
  },
  {
    name: "Applied Portion (%)",
    col: 3
  },
  {
    name: "",
    col: 4
  }
];

const LandUsageTableHeader = [
  {
    name: "Year of Change",
    col: 3
  },
  {
    name: "Allocation (%)",
    col: 3
  },
  {
    name: "Land usage from",
    col: 3
  },
  {
    name: "Land usage to",
    col: 3
  },
  {
    name: "",
    col: 4
  }
];

const EnergySourceData = [
  {
    name: "Energy Source",
    col: 4
  },
  {
    name: "Energy Used ",
    col: 4
  },
  {
    name: "Energy Unit type",
    col: 4
  },
  {
    name: "",
    col: 4
  }
];

const FertilizerTableHeader = [
  {
    name: "Fertilizer Name",
    col: 6
  },
  {
    name: "kg/ha",
    col: 6
  },
  {
    name: "",
    col: 4
  }
];

const ProcessHeatTableHeader = [
  {
    name: "Heat Source",
    col: 7
  },
  {
    name: "Heating Amount (MJ/kg)",
    col: 6
  },
  {
    name: "",
    col: 4
  }
];

const CommonCol = [
  {
    name: "Name",
    col: 8
  },
  {
    name: "Content",
    col: 5
  },
  {
    name: "Unit",
    col: 3
  }
];

const SipCol = [
  {
    name: "Chemical Name",
    col: 4
  },
  {
    name: "Concentration",
    col: 4
  },
  {
    name: "Consumption",
    col: 4
  },
  {
    name: "",
    col: 4
  }
];

const PackagingColDetails = [
  {
    name: "Product Name",
    col: 3
  },
  {
    name: "Unit Size ",
    col: 3
  },
  {
    name: "Unit Type",
    col: 4
  },
  {
    name: "EAN Barcode",
    col: 3
  },
  {
    name: "",
    col: 4
  }
];

const IngredientViewProductCol = [
  {
    name: "Product Name",
    col: 3
  },
  {
    name: "Unit Name",
    col: 3
  },
  {
    name: "Unit Size",
    col: 3
  },
  {
    name: "Unit Type",
    col: 3
  },
  {
    name: "EAN Barcode",
    col: 3
  }
];

const SupplierIngredientTabCol = [
  {
    name: "Ingredient Name",
    col: 3
  },
  {
    name: "Supplier Name",
    col: 3
  },
  {
    name: "Unit Size",
    col: 3
  },

  {
    name: "EAN Barcode",
    col: 3
  },
  {
    name: "",
    col: 2
  },
  {
    name: "",
    col: 2
  }
];

const Processing = [
  {
    name: "Process Name",
    col: 1
  },
  {
    name: "Processing Type",
    col: 1
  },
  {
    name: "input",
    col: 1
  },
  {
    name: "output",
    col: 1
  },
  {
    name: "capacity",
    col: 1
  }
];

const Packaging = [
  {
    name: "Meaterial Weight",
    col: 2
  },
  {
    name: "Package Material",
    col: 2
  },
  {
    name: "Package Name",
    col: 2
  }
];

const Storage = [
  {
    name: "Warehouse Name",
    col: 2
  },
  {
    name: "Warehouse Size",
    col: 2
  },
  {
    name: "Temperature",
    col: 2
  },
  {
    name: "Electricity",
    col: 2
  }
];

const Energy = [
  {
    name: "Energy Type",
    col: 2
  },
  {
    name: "kWh",
    col: 2
  },
  {
    name: "Percentage",
    col: 2
  }
];

const Transportation = [
  {
    name: "Transport Type",
    col: 2
  },
  {
    name: "Average Distance",
    col: 2
  }
];

const ProductUnitTable = [
  {
    name: "Unit Name",
    col: 3
  },
  {
    name: "Unit Size",
    col: 3
  },
  {
    name: "Unit Type",
    col: 3
  },
  {
    name: "EAN Number",
    col: 3
  },
  {
    name: "",
    col: 3
  }
];

const ClientTransportMethodsTable = [
  {
    name: "Transport Type",
    col: 3
  },
  {
    name: "From",
    col: 3
  },
  {
    name: "To",
    col: 3
  },
  {
    name: "Distance (Km)",
    col: 2
  },
  {
    name: "Weight (Kg)",
    col: 2
  },
  {
    name: "",
    col: 2
  }
];

const SupplierIngredientTable = [
  {
    name: "Ingredient Name",
    col: 4
  },
  {
    name: "Unit Size",
    col: 3
  },
  {
    name: "Unit Type",
    col: 3
  },
  {
    name: "EAN Number",
    col: 3
  },
  {
    name: "",
    col: 3
  }
];

const ProductSummaryTableCol = [
  {
    name: "Impact category",
    col: 6
  },
  {
    name: "Result",
    col: 6
  },
  {
    name: "Reference unit per kg",
    col: 3
  },
  {
    name: "",
    col: 1
  }
];

const ProductSummaryHistoryTableCol = [
  {
    name: "Date",
    col: 6
  },
  {
    name: "Climate Change Impact (kgCO2eq/kg)",
    col: 4
  },
  {
    name: "Calculated Version",
    col: 1
  },
  {
    name: "",
    col: 3
  }
];

const CultivationPackagingView = [
  {
    name: "Packaging Name",
    col: 4
  },
  {
    name: "Packaging Material",
    col: 4
  },
  {
    name: "Material Weight",
    col: 3
  },
  {
    name: "Material Cost",
    col: 3
  },
  {
    name: "",
    col: 2
  }
];

const TransportDetailsView = [
  {
    name: "From",
    col: 3
  },
  {
    name: "To",
    col: 3
  },
  {
    name: "Transportation type",
    col: 3
  },
  {
    name: "Distance",
    col: 3
  },
  {
    name: "Weight",
    col: 3
  },
  {
    name: "",
    col: 4
  }
];

const CultivationPackagingMethodView = [
  {
    name: "Packaging Step",
    col: 3
  },
  {
    name: "Packaging Machinary",
    col: 3
  },
  {
    name: "Packaging Level",
    col: 2
  },
  {
    name: "Energy",
    col: 1
  },
  {
    name: "Capacity(pk/hr)",
    col: 1
  },
  {
    name: "Waste(pk/hr)",
    col: 1
  },
  {
    name: "",
    col: 2
  }
];

const FacilityTableCol = [
  {
    name: "Facility Name",
    col: 3
  },
  {
    name: "Facility Type",
    col: 3
  },
  {
    name: "",
    col: 2
  }
];

const FacilityEnergyTable = [
  {
    name: "Year",
    col: 2
  },
  {
    name: "Source",
    col: 3
  },
  {
    name: "kWh consumed",
    col: 2
  },
  {
    name: "Distribution",
    col: 2
  },
  {
    name: "Price per kWh",
    col: 2
  },
  {
    name: "Total cost",
    col: 2
  },
  {
    name: "",
    col: 3
  }
];

const FacilityHeatTable = [
  {
    name: "Year",
    col: 3
  },
  {
    name: "Source",
    col: 3
  },
  {
    name: "Volume",
    col: 2
  },
  {
    name: "Price per unit",
    col: 2
  },
  {
    name: "Total price",
    col: 2
  },
  {
    name: "",
    col: 2
  }
];

const FacilityWaterTable = [
  {
    name: "Year",
    col: 3
  },
  {
    name: "Source",
    col: 3
  },
  {
    name: "Volume",
    col: 2
  },
  {
    name: "Price per unit",
    col: 2
  },
  {
    name: "Total price",
    col: 2
  },
  {
    name: "",
    col: 2
  }
];

const ChemicalDataCol = [
  {
    name: "Process Chemicals Name",
    col: 4
  },
  {
    name: "Chemical",
    col: 4
  },
  {
    name: "Chemical Amount (kg/kg input)",
    col: 4
  },
  {
    name: "",
    col: 8
  }
];

const CommercialChemicalDataCol = [
  {
    name: "Chemical Name",
    col: 8
  },
  {
    name: "Chemical Amount (kg/kg input)",
    col: 4
  },
  {
    name: "",
    col: 4
  }
];

const NoteDocumentTable = [
  {
    name: "",
    col: 1
  },
  {
    name: "Document Name",
    col: 7
  },
  {
    name: "Upload on",
    col: 4
  },
  {
    name: "",
    col: 4
  }
];

const TransportTypeCol = [
  {
    name: "Transportation Type",
    col: 6
  },
  {
    name: "Distance",
    col: 6
  },
  {
    name: "",
    col: 4
  }
];

const chemicalMixTableHeaders = [
  { name: "Chemical Name", col: 8 },
  { name: "Amount (%)", col: 4 },
  { name: "Action", col: 4 }
];

const ValueAndCostTable = [
  {
    name: "Year",
    col: 3
  },
  {
    name: "Number of units",
    col: 3
  },
  {
    name: "Volume (kg)",
    col: 3
  },
  {
    name: "Price per unit",
    col: 3
  },
  {
    name: "",
    col: 4
  }
];

const TransportSimulateCol = [
  {
    name: "Chemical name",
    col: 4
  },
  {
    name: "Chemical Amount (kg/kg input)",
    col: 4
  },
  {
    name: "Transportation Type",
    col: 4
  },
  {
    name: "Distance",
    col: 4
  }
];

const RecipeIngredientCol = [
  {
    name: "Ingredient  Name",
    col: 4
  },
  {
    name: "Added on",
    col: 12
  }
];

const GenericProcessCol = [
  {
    name: "Process  Name",
    col: 4
  },
  {
    name: "Added on",
    col: 12
  }
];

const RecipeVariantCol = [
  {
    name: "Variant Name",
    col: 3
  },
  {
    name: "Baseline impact (kgCO2eq/kg)",
    col: 2,
    textAlign: "right"
  },
  {
    name: "Variant Impact (kgCO2eq/kg)",
    col: 2,
    textAlign: "right"
  },
  {
    name: "Variant Impact Total(kgCO2eq)*",
    col: 3,
    textAlign: "right"
  },
  {
    name: "Impact Change %",
    col: 2,
    textAlign: "right"
  },
  {
    name: "Total Impact Change (kgCO2eq)*",
    col: 3,
    textAlign: "right"
  },
  {
    name: "",
    col: 1
  }
];

const WasteManagementDataCol = [
  {
    name: "Management Name",
    col: 1
  },
  {
    name: "Management Type",
    col: 2
  },
  {
    name: "Moisture content (%)",
    col: 2
  },
  {
    name: "Ingredient Name",
    col: 2
  },
  {
    name: "Distribution (kg)",
    col: 2
  },
  {
    name: "",
    col: 2
  }
];

const NotificationCol = [
  {
    name: "Ingredient Name",
    col: 3
  },
  {
    name: "Company Name",
    col: 3
  },
  {
    name: "Product Name",
    col: 3
  },
  {
    name: "Request accepted on",
    col: 4
  },
  {
    name: "Shared on date",
    col: 6
  }
];

const SimulationDataTable = [
  {
    name: "",
    col: 1
  },
  {
    name: "Simulation Name",
    col: 3
  },
  {
    name: "Original Impact",
    col: 3
  },
  {
    name: "Simulated Impact",
    col: 3
  },
  {
    name: "Impact Change Impact %",
    col: 3
  },
  {
    name: "",
    col: 3
  }
];

const SimulationPackagingTable = [
  {
    name: "Category",
    col: 2
  },
  {
    name: "Name",
    col: 2
  },
  {
    name: "Original Impact (kgCO2 eq)",
    col: 3
  },
  {
    name: "Simulated Impact (kgCO2 eq)",
    col: 3
  },
  {
    name: "Impact Change Impact %",
    col: 3
  },
  {
    name: "",
    col: 3
  }
];

const SupplierListCol = [
  {
    name: "Supplier Name"
  },
  {
    name: "Contact Name"
  },
  {
    name: "Supplier Email"
  },
  {
    name: "Contact Number"
  },
  {
    name: ""
  }
];

const SupplierRequestCol = [
  {
    name: "",
    col: 2
  },
  {
    name: "Supplier Name",
    col: 3
  },
  {
    name: "Ingredient name",
    col: 3
  },
  {
    name: "Status",
    col: 2
  },
  {
    name: "Date",
    col: 3
  },
  {
    name: "",
    col: 2
  }
];

const fixedColumns = [
  { title: "Ingredients", custom: true },
  { title: "Baseline (%)", custom: false }
];

const facilitySimulationTableCol = [
  {
    name: "Facility Name",
    col: 12
  },
  {
    name: "",
    col: 4
  }
];

const JourneyTableHeader = [
  { name: "Journey Name", col: 4 },
  { name: "Transportation Types", col: 4 },
  { name: "Distance", col: 4 },
  { name: "", col: 4 }
];

const CALCULATED_VERSION_PREFIX = "EF";

export {
  CALCULATED_VERSION_PREFIX,
  ChemicalDataCol,
  chemicalMixTableHeaders,
  ChemicalTableColView,
  ClientListTableCol,
  ClientTableCol,
  ClientTransportMethodsTable,
  CommercialChemicalDataCol,
  CommonCol,
  CompanyTableCol,
  CultivationPackagingMethodView,
  CultivationPackagingView,
  Energy,
  EnergySourceData,
  FacilityEnergyTable,
  FacilityHeatTable,
  facilitySimulationTableCol,
  FacilityTableCol,
  FacilityWaterTable,
  FertilizerTableHeader,
  fixedColumns,
  GenericProcessCol,
  IngredientTableColView,
  IngredientViewProductCol,
  IrrigationTableHeader,
  JourneyTableHeader,
  LandUsageTableHeader,
  NoteDocumentTable,
  NotificationCol,
  Packaging,
  PackagingColDetails,
  PesticideTableHeader,
  ProcessHeatTableHeader,
  Processing,
  ProductSummaryHistoryTableCol,
  ProductSummaryTableCol,
  ProductTableCol,
  ProductUnitTable,
  RecipeIngredientCol,
  RecipeSimulatorTableColView,
  RecipeVariantCol,
  SimulationDataTable,
  SimulationPackagingTable,
  SipCol,
  Storage,
  SupplierIngredientTabCol,
  SupplierIngredientTable,
  SupplierListCol,
  SupplierRequestCol,
  Transportation,
  TransportDetailsView,
  TransportSimulateCol,
  TransportTableCol,
  TransportTypeCol,
  UserTableCol,
  ValueAndCostTable,
  WasteManagementDataCol
};
